import type { IFallBackTranslations } from '@/Templates/FallBack/Types/translations';

const esES: IFallBackTranslations = {
  notFound: {
    title: '¡Ups!',
    subtitle: 'Página no encontrada',
    description: 'Parece que te has desconectado de nuestro mundo AIoT...',
    button: 'Volver a inicio',
  },
  maintanance: {
    title: '¡Ya volvemos!',
    subtitle: 'Estamos haciendo algunos ajustes',
    description:
      'Estamos mejorando tu experiencia. ¡Pronto todo estará aún mejor! Puedes actualizar la página o volver más tarde.',
  },
  instability: {
    title: '¡Espera!',
    subtitle: 'Estamos experimentando alguna inestabilidad',
    description:
      'Nuestro sistema está experimentando inestabilidad temporal. Estamos trabajando para restaurar la funcionalidad completa. Por favor, intenta nuevamente en unos momentos.',
  },
};

export { esES };
